import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const RegistrationSuccess = () => {
  const location = useLocation();
  const { email, emailFailed = false } = location.state || {};

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8 font-inter">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Card Container */}
        <div className="bg-white py-8 px-6 shadow-sm rounded-lg sm:px-10 border border-gray-100">

          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-xl font-semibold text-gray-900 text-center mb-2">
            Account Created Successfully
          </h1>

          {/* Main Content */}
          <div className="text-center mb-6">
            {emailFailed ? (
              <>
                <p className="text-gray-600 mb-4">
                  Your account has been created, but we encountered an issue sending your verification email.
                </p>
                <div className="bg-yellow-50 border border-yellow-100 rounded-md p-4">
                  <p className="text-yellow-800 text-sm">
                    We'll automatically retry sending the verification email. You can also request a new one from your account settings.
                  </p>
                </div>
              </>
            ) : (
              <>
                <p className="text-gray-600 mb-3">
                  A verification link has been sent to:
                </p>
                <p className="text-[12px] font-medium text-gray-900 bg-gray-50 py-2 px-4 rounded-md inline-block">
                  {email}
                </p>
                <p className="text-gray-600 mt-4 text-sm">
                  Click the verification link in the email to activate your account.
                </p>
              </>
            )}
          </div>

          {/* Next Steps */}
          <div className="bg-teal-50 border border-teal-100 rounded-md p-4 mb-6">
            <h3 className="font-medium text-teal-900 mb-3 text-sm">What's Next?</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center text-teal-800">
                <span className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center text-xs font-medium mr-3">1</span>
                Check your email inbox
              </div>
              <div className="flex items-center text-teal-800">
                <span className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center text-xs font-medium mr-3">2</span>
                Click the verification link
              </div>
              <div className="flex items-center text-teal-800">
                <span className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center text-xs font-medium mr-3">3</span>
                Start using your account
              </div>
            </div>
          </div>

          {/* Help Section */}
          <div className="text-center space-y-4">
            {!emailFailed && (
              <div className="mt-4">
                <Link
                  to="/resend-verification"
                  state={{ email }}
                  className="inline-flex items-center text-teal-600 hover:text-teal-500 font-medium text-sm transition-colors"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                  Didn't receive the email? Resend verification
                </Link>
              </div>
            )}
            <div className="pt-4 border-t border-gray-200">
              <p className="text-xs text-gray-500">
                Need assistance? Contact us at support@cropser.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;